<template>
  <b-breadcrumb
    v-if="showBreadcrumbs"
    class="m-0"
  >
    <BreadcrumbItem
      v-if="items[0].path !== PATH_ROOT"
      :label="rootLabel"
      :last="false"
      :index="0"
      path="root"
    />
    <BreadcrumbItem
      v-for="({label, path}, index) in items"
      :key="'breadcrumb' + path"
      :label="label"
      :last="items.length-1 === index"
      :path="path"
    />
  </b-breadcrumb>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'
import BreadcrumbItem from '@/components/public/BreadcrumbItem.vue'
import { PATH_ROOT } from '@/constants'
import { Path } from '@/types'

const components = {
  BreadcrumbItem,
}

@Component({ components })
export default class ClickableBreadcrumbs extends Vue {
  PATH_ROOT = PATH_ROOT

  get showBreadcrumbs () {
    return this.$typedStore.activeVisualisation.displaysTreeData
  }

  get storyPath () {
    return this.$typedStore.activeVisualisation.storyPath
  }

  get items () {
    return this.storyPath.partPaths.map(path => ({
      path: path.toString(),
      label: path.level === this.$typedStore.activeVisualisation.leafLevel
        ? this.projectLabel
        : this.getLabel(path),
    }))
  }

  get projectLabelField () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.appConfig.projectLabelField
  }

  get projectLabel () {
    const treeItem = this.$typedStore.visualisationData.treeRoot.search(this.storyPath)
    return treeItem && treeItem?.data && treeItem.data[this.projectLabelField]
  }

  get rootLabel () {
    return this.getLabel(Path.root)
  }

  getLabel (path: Path) {
    return this.$typedStore.activeVisualisation.visualisationStore.entities.nodes.label(path) || path.name
  }
}
</script>

<style lang="scss">
$breadcrumb-item-padding: 1rem !default;
.breadcrumb {
  &.desktop {
    background-color: transparent;
    font-weight: 600;

    .breadcrumb-item {
      a {
        color: black;
      }
      &.active {
        color: black;
      }
      + .breadcrumb-item {
        padding-left: $breadcrumb-item-padding;

        &::before {
          padding-right: $breadcrumb-item-padding;
          content: "\\";
        }
      }
    }
  }
}
</style>
